<template>
        <Photo />
</template>

<script>
import Photo from '@/components/Photo.vue'
export default {
    name: 'photoview',
    components: {
        Photo,
    }
};
</script>